import { Global } from '@emotion/react';
import { MantineProvider } from '@mantine/core';
import ReactDOM from 'react-dom/client';
import App from './App';
import gothicOTF from './font/NanumGothic.otf';
import gothicTTF from './font/NanumGothic.ttf';
import gothicBoldOTF from './font/NanumGothicBold.otf';
import gothicBoldTTF from './font/NanumGothicBold.ttf';
import { buildMantineTheme } from './theme/mantineTheme';
import i18n from './translation/i18n';
import {
  parseEmbedOptionsFromSearch,
  parseThemeColorsFromSearch,
  themeColorsToCssVars,
} from './utils/themeFromUrl';

function FontProvider() {
  return (
    <Global
      styles={[
        {
          '@font-face': {
            fontFamily: 'nanum_gothic',
            src: `url('${gothicOTF}') format("truetype"), url('${gothicTTF}') format("woff")`,
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
        },
        {
          '@font-face': {
            fontFamily: 'nanum_gothic',
            src: `url('${gothicBoldOTF}') format("truetype"), url('${gothicBoldTTF}') format("woff")`,
            fontStyle: 'normal',
            fontWeight: 'bold',
          },
        },
      ]}
    />
  );
}

const themeColors = parseThemeColorsFromSearch();
const { embed, lang } = parseEmbedOptionsFromSearch();
const mantineTheme = buildMantineTheme(themeColors);

if (lang) {
  i18n.changeLanguage(lang);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={mantineTheme}
  >
    <Global styles={{ ':root': themeColorsToCssVars(themeColors) }} />
    <FontProvider />
    <App embed={embed} />
  </MantineProvider>,
);
